module.exports = {
  navTheme: 'dark', // theme for nav menu
  primaryColor: 'yellow',//'#1DA57A', // primary color of ant design
  linkColor: 'yellow', //'#1DA57A',
  layout: 'topmenu', // nav menu position: sidemenu or topmenu
  contentWidth: 'Fluid', // layout of content: Fluid or Fixed, only works when layout is topmenu
  fixedHeader: false, // sticky header
  autoHideHeader: false, // auto hide header
  fixSiderbar: true, // sticky siderbar
  locale: 'vi',
 // adminName: 'Urbox', // name admin on header,
  collapsedWidth: '60px',
  uncollapsedWidth: '220px'
};
